export default {
  "wp-contract-card": {
    name: "Карточка договора",
    title: {
      new: "Новый договор",
      update: "Редактирование договора",
    },
    actions: {
      saveButton: "Сохранить",
    },
    labels: {
      details: {
        topLabel: "Сведения",
        name: "Название",
        number: "Номер",
        customer: "Заказчик",
        contractor: "Исполнитель",
        period: "Период действия договора",
        active: "Активный договор",
        note: "Заметка",
        responsiblePerson: "Ответственный",
        isContractWithoutTime: "Бессрочный договор",
      },
    },
    preferences: {
      dateFormat: "DD.MM.YYYY",
    },
    validationRules: {
      defaults: {
        required: "Требуется ввести значение",
        minLength: "Значение должно быть не менее {0} символов",
        maxLength: "Значение должно занимать не более {0} символов",
        min: "Дата должна быть не ранее 01.01.1900 г.",
        hasResponsiblePersonEmail: "У ответственного должен быть email",
      },
    },
  },
};
